import axios from 'axios'
import { dataEnv } from '../../config/index.js'

/**
 * Function to get token
 * @param {Object} payload
 * @return AxiosPromise
 */
export const setDataEmisora = (payload) => {
  return axios.post(`${dataEnv().API_URL}/radio-stations/step/0`, payload)
}

/**
 * Function to get token
 * @param {Object} payload
 * @return AxiosPromise
 */
export const StyleMusic = () => {
  return axios.get(`${dataEnv().API_URL}/music-styles`)
}

/**
 * Function to get token
 * @param {Object} payload
 * @return AxiosPromise
 */
export const GetStates = () => {
  return axios.get(`${dataEnv().API_URL}/states`)
}

/**
 * Function to get token
 * @param {Object} payload
 * @return AxiosPromise
 */
export const saveUser = (payload) => {
  return axios.post(`${dataEnv().API_URL}/register/user`, payload)
}

/**
 * Function to get token
 * @param {Object} payload
 * @return AxiosPromise
 */
export const deleteUser = (payload) => {
  return axios.put(`${dataEnv().API_URL}/user/delete`, payload)
}

/**
 * Function to get token
 * @param {Object} payload
 * @return AxiosPromise
 */
export const saveAudience = (payload) => {
  return axios.post(`${dataEnv().API_URL}/radio-stations/step/2`, payload)
}

/**
 * Function to get token
 * @param {Object} payload
 * @return AxiosPromise
 */
export const saveTarifa = (payload, step) => {
  return axios.post(`${dataEnv().API_URL}/radio-stations/step/${step}`, payload)
}

/**
 * Function to get token
 * @param {Object} payload
 * @return AxiosPromise
 */
export const radioStationProfile = (id) => {
  return axios.get(`${dataEnv().API_URL}/radio-stations/${id}/info`)
}

/**
 * Function to get token
 * @param {Object} payload
 * @return AxiosPromise
 */
export const userList = (id, typeid) => {
  return axios.get(`${dataEnv().API_URL}/userlist/${id}/${typeid}`)
}

/**
 * Function to get token
 * @param {Object} payload
 * @return AxiosPromise
 */
export const userListClient = (id, typeid) => {
  return axios.get(`${dataEnv().API_URL}/userlist-client/${id}/${typeid}`)
}

/**
 * Function to get token
 * @param {Object} payload
 * @return AxiosPromise
 */
export const updateStation = (payload) => {
  return axios.post(`${dataEnv().API_URL}/radio-stations/step/1`, payload)
}

/**
 * Function to get token
 * @param {Object} payload
 * @return AxiosPromise
 */
export const updateAudience = (payload) => {
  return axios.put(`${dataEnv().API_URL}/radio-stations/update`, payload)
}

/**
 * Function to get token
 * @param {Object} payload
 * @return AxiosPromise
 */
export const updateUsers = (payload) => {
  return axios.post(`${dataEnv().API_URL}/radio-stations/step/4`, payload)
}
